export default __webpack_public_path__ + "static/media/userOrdersImg.ebc11640.svg";